import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { AnyAction } from "../utils/ReducerUtils";
import { userReducer, userReducerPersistConfig, UserReducerState } from "../reducers/UserReducer";
import { appReducer, appReducerPersistConfig, AppReducerState } from "../reducers/AppReducer";
import { authReducer, authReducerPersistConfig, AuthReducerState } from "../reducers/AuthReducer";

export interface AppStoreState {
  readonly user: UserReducerState;
  readonly app: AppReducerState;
  readonly auth: AuthReducerState;
}

export const rootReducer = combineReducers<any>({
  user: persistReducer<UserReducerState, AnyAction>(
    {
      ...userReducerPersistConfig,
      key: "user",
      storage,
    },
    userReducer,
  ),
  app: persistReducer<AppReducerState, AnyAction>(
    {
      ...appReducerPersistConfig,
      key: "app",
      storage,
    },
    appReducer,
  ),
  auth: persistReducer<AuthReducerState, AnyAction>(
    {
      ...authReducerPersistConfig,
      key: "auth",
      storage,
    },
    authReducer,
  ),
});
